/**
 * SPDX-License-Identifier: MPL-2.0
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2023-2024 (c) Daniel Littfinski, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import Fairs from './Fair';
import NewFair from './_fairExample.json';
import { FairActions } from './FairActions';
import { IFairsState } from './FairsReducer';
import { RootState } from '../reducer';
import { Fair } from 'Api/generated';
import { AllowedRoles } from 'Contexts/Auth';

const newFair: Fair = NewFair;

interface IFairList {
  fairs: IFairsState;
}

const getKeys = Object.keys as <T extends object>(obj: T) => Array<keyof T>;

const FairList = ({ fairs }: IFairList) => {
  const dispatch = useDispatch();

  useEffect(() => {
    FairActions.QueryFairs()(dispatch);
  }, [dispatch]);

  console.log(fairs);
  const keys = getKeys(fairs.Fairs).sort((a, b) =>
    a.toString().localeCompare(b.toString(), undefined, { sensitivity: 'base' }),
  );

  return (
    <AllowedRoles roles={['SuperAdmin', 'Admin']}>
      <div>
        <ul>
          {keys.map((key) => {
            return <Fairs key={key} existingFairTags={fairs.fairTags} fair={fairs.Fairs[key]} isAdd={false}></Fairs>;
          })}
        </ul>
        <ul>
          <Fairs key="New" fair={newFair} existingFairTags={fairs.fairTags} isAdd={true}></Fairs>
        </ul>
      </div>
    </AllowedRoles>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    fairs: state.fairs,
  };
};

export default connect(mapStateToProps)(FairList);
